<template>
  <div>
    <div class="text-center mt-3 w-100">
      <button @click="showAddress()" class="btn btn-primary w-75">
        <i class="fas fa-arrow-left"></i>&nbsp;Zurück (Alle Kleber an Adresse:
        {{ servicekleber.address.tib.name }})
      </button>
    </div>

    <div class="modal-dialog modal-xl mt-3" role="document" v-if="doEdit">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Servicekleber</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="cancel()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group">
              <label for="name">Name</label>
              <input
                ref="nameInput"
                type="text"
                class="form-control"
                id="name"
                placeholder="name"
                v-model="servicekleber.tib.name"
              />
            </div>
            <div class="form-group">
              <label for="name">Features</label>
              <stringlist
                :list="servicekleber.tib.flagsList"
                :edit="true"
              ></stringlist>
            </div>
            <div class="form-group">
              <label for="description">Beschreibung</label>
              <markedarea
                id="description"
                v-model="servicekleber.data.description"
              ></markedarea>
            </div>
            <div class="form-group">
              <label for="popupMessage">Nachricht</label>
              <markedarea
                id="popupMessage"
                v-model="servicekleber.data.popupMessage"
              ></markedarea>
              <p class="help">{{ tp.popupMessageHelp }}</p>
            </div>
            <div class="form-group">
              <label for="tenant">Mandant</label>
              <input
                type="text"
                class="form-control"
                id="tenant"
                placeholder="tenant"
                v-model="servicekleber.data.tenant"
              />
            </div>
            <div class="form-group">
              <label for="floor">Stockwerk</label>
              <input
                type="text"
                class="form-control"
                id="floor"
                placeholder="floor"
                v-model="servicekleber.data.floor"
              />
            </div>
            <div class="form-group">
              <label for="deviceLocation">Standort Details</label>
              <input
                type="text"
                class="form-control"
                id="deviceLocation"
                placeholder="deviceLocation"
                v-model.trim="servicekleber.data.deviceLocation"
              />
            </div>
            <div class="form-group">
              <label for="manufacturer">Hersteller</label>
              <input
                type="text"
                class="form-control"
                id="manufacturer"
                placeholder="manufacturer"
                v-model.trim="servicekleber.data.manufacturer"
              />
            </div>
            <div class="form-group">
              <label for="deviceName">Gerätename</label>
              <input
                type="text"
                class="form-control"
                id="deviceName"
                placeholder="deviceName"
                v-model.trim="servicekleber.data.deviceName"
              />
            </div>
            <div class="form-group">
              <label for="deviceType">Gerätetyp</label>
              <input
                type="text"
                class="form-control"
                id="deviceType"
                placeholder="deviceType"
                v-model.trim="servicekleber.data.deviceType"
              />
            </div>
            <div class="form-group">
              <label for="serialNumber">Seriennummer</label>
              <input
                type="text"
                class="form-control"
                id="serialNumber"
                placeholder="serialNumber"
                v-model.trim="servicekleber.data.serialNumber"
              />
            </div>
            <div class="form-group">
              <label for="deviceNumber">Typennummer</label>
              <input
                type="text"
                class="form-control"
                id="deviceNumber"
                placeholder="deviceNumber"
                v-model.trim="servicekleber.data.deviceNumber"
              />
            </div>
            <div class="form-group">
              <label for="addOns">Zusatzgeräte</label>
              <input
                type="text"
                class="form-control"
                id="addOns"
                placeholder="addOns"
                v-model.trim="servicekleber.data.addOns"
              />
            </div>
            <div class="form-group">
              <label for="payAccount">QR Zahlfunktion Firma (payAccount)</label>
              <input
                type="text"
                class="form-control"
                id="payAccount"
                placeholder="payAccount"
                v-model.trim="servicekleber.tib.attributesMap.payAccount"
              />
            </div>
            <div class="form-group">
              <label for="regId">QR Zahlfunktion Referenz (regId)</label>
              <input
                type="text"
                class="form-control"
                id="regId"
                placeholder="regId"
                v-model.trim="servicekleber.tib.attributesMap.regId"
              />
            </div>
            <div class="form-group">
              <label for="tag">Tag</label>
              <input
                type="text"
                class="form-control"
                id="tag"
                placeholder="tag"
                v-model.trim="servicekleber.tib.tag"
              />
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="row mx-auto">
            <div class="col-xs-6 mx-1">
              <button
                @click="updateTib()"
                type="button"
                class="btn btn-outline-dark btn-block"
              >
                <i class="far fa-save"></i>&nbsp;Speichern
              </button>
            </div>
            <div class="col-xs-6 mx-1">
              <button
                @click="editMode(false)"
                type="button"
                class="btn btn-outline-dark btn-block"
                data-dismiss="modal"
              >
                <i class="far fa-times-circle"></i>&nbsp;Abbrechen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="formTableContainer mt-3" v-if="!doEdit">
      <div class="d-flex justify-content-between">
        <div>
          <h3>
            {{
              servicekleber.tib.name == servicekleber.tib.name
                ? servicekleber.tib.name
                : servicekleber.tib.name + " " + servicekleber.data.extRef
            }}
          </h3>
          <div>
            {{ servicekleber.address.tib.name }}
            {{ servicekleber.data && servicekleber.data.tenant }},
            {{ servicekleber.address.data.address }},
            {{ servicekleber.address.data.city }}
          </div>
        </div>
        <div>
          <a :href="'/tt/ib/' + servicekleber.tib.tag" target="_blank"
            ><img
              class="img-responsive"
              :src="'/tt/tib/' + servicekleber.tib.tag + '/qr.png?size=100'"
          /></a>
        </div>
      </div>
      <table class="formTable mx-auto w-100">
        <tr>
          <td colspan="2">
            <div
              class="md w-100"
              style="display:block; background-color: #9acfea"
              v-html="markedHtml(servicekleber.data.description)"
            ></div>
          </td>
        </tr>
        <tr v-if="!isEmptyString(servicekleber.data.popupMessage)">
          <td colspan="2">
            <div
              class="md wkMessageInline"
              v-html="markedHtml(servicekleber.data.popupMessage)"
            ></div>
          </td>
        </tr>
        <tr>
          <td>{{ tp.floor }}:</td>
          <td>{{ servicekleber.data && servicekleber.data.floor }}</td>
          <td v-if="doEdit">
            <input
              type="text"
              class="w-100"
              v-model="servicekleber.data.floor"
            />
          </td>
        </tr>
        <tr>
          <td>{{ tp.extRef }}:</td>
          <td>{{ servicekleber.data && servicekleber.data.extRef }}</td>
          <td v-if="doEdit">
            <input
              type="text"
              class="w-100"
              v-model="servicekleber.data.extRef"
            />
          </td>
        </tr>
        <tr v-if="newTibTagProperty">
          <td>Tag:</td>
          <td>{{ servicekleber.tib.tag && servicekleber.tib.tag }}</td>
        </tr>
      </table>
    </div>
    <div class="mx-auto mt-3" v-if="!doEdit">
      <button
        v-if="newTibTagProperty"
        @click="updateTibTag()"
        class="btn btn-outline-dark btn-block"
      >
        <i class="fas fa-edit"></i>&nbsp;Neuen QR Code hier zuordnen
      </button>
      <button
        v-if="!newTibTagProperty"
        @click="editMode(true)"
        class="btn btn-outline-dark btn-block"
      >
        <i class="fas fa-edit"></i>&nbsp;Bearbeiten
      </button>
    </div>

    <div class="mt-3" v-if="!doEdit">
      <h2>Benutzer benachrichtigen</h2>
      <p class="small">
        Hier können Sie eine Liste von Benutzern verwalten, die per E-mail
        benachrichtigt werden, sobald eine Nachricht zu diesem Kleber erfasst
        wurde. Die Liste wird mit derjenigen Person erweitert, welche die
        Nachricht erfasst hat, falls diese nicht bereits in der Liste vorkommt.
        Administratoren von TiBTiX werden immer benachrichtigt und müssen nicht
        in dieser Liste aufgeführt werden
      </p>
      <notification
        @savenotification="updateTib()"
        v-model="servicekleber.tib.notify"
      ></notification>
    </div>

    <div class="mt-3" v-if="!doEdit">
      <h2>{{ tp.journal }}</h2>
      <journalComponent
        v-if="!doEdit"
        ref="journalComponent"
        @savetib="updateTib"
        @savejournalentry="saveJournalEntry"
        :loggedIn="true"
        :tibModelProperty="servicekleber.tib"
        :tp="tp"
      ></journalComponent>
    </div>

    <div class="mt-3" v-if="!doEdit">
      <h2>{{ tp.tibs }}</h2>
      <div
        class="mx-auto"
        v-for="(tib, index) in servicekleber.tibs"
        :key="index"
      >
        <tibDetails :tibModelProperty="tib" @tibdeleted="removeTib" :tp="tp">
        </tibDetails>
      </div>
    </div>
  </div>
</template>

<script>
import { TT_URL } from "@/common/constants";
import axios from "axios";

import { markedHtml, isEmptyString } from "@/common/utils";
import notification from "@/components/notification/Notification.vue";
import journalComponent from "@/components/journal/JournalComponent.vue";
import tibDetails from "@/components/TibDetails.vue";
import stringlist from "@/components/util/StringList.vue";
import markedarea from "@/components/marked/MarkedArea.vue";
export default {
  name: "servicekleberDetails",
  components: {
    notification,
    journalComponent,
    tibDetails,
    stringlist,
    markedarea
  },
  data: function() {
    return {
      servicekleber: this.servicekleberProperty,
      doEdit: this.doEditProperty,
      oldTibName: "",
      markedHtml: markedHtml,
      isEmptyString: isEmptyString
    };
  },
  mounted() {
    this.servicekleber = this.servicekleberProperty;
    if (this.servicekleber.doEdit) {
      this.editMode(true);
      this.servicekleber.doEdit = false;
    }
  },
  watch: {
    servicekleberProperty() {
      this.servicekleber = this.servicekleberProperty;
    }
  },
  methods: {
    updateTib() {
      let self = this;
      this.servicekleber.tib.data = JSON.stringify(this.servicekleber.data);
      axios
        .post(TT_URL + "/api/rest/tibtix/updateTib", this.servicekleber.tib)
        .then(response => {
          console.info("servicekleber saved: " + response);
        })
        .catch(function(error) {
          self.$emit("error", "An error has occurred." + "\n" + error);
        });
      console.info("tibupdated");
      this.$emit("tibupdated");
      this.doEdit = false;
    },
    updateTibTag() {
      let self = this;
      var update = {
        oldTag: this.servicekleber.tib.tag,
        newTag: this.newTibTagProperty
      };
      axios
        .post(TT_URL + "/api/tib/updateTibTag", update)
        .then(response => {
          console.info("servicekleber tag updated");
          this.servicekleber.tib = response.data;
          self.$emit("tibTagChanged");
        })
        .catch(function(error) {
          self.$emit("error", "An error has occurred." + "\n" + error);
        });
    },
    saveJournalEntry(journalEntry) {
      this.$emit("savejournalentry", journalEntry);
    },
    editMode(on) {
      this.doEdit = on;
      if (on) {
        this.oldTibName = this.servicekleber.tib.name;
        this.focusNameInput();
      } else {
        this.servicekleber.tib.name = this.oldTibName;
        this.servicekleber.data = JSON.parse(this.servicekleber.tib.data);
      }
    },
    showAddress() {
      if (this.doEdit) {
        this.editMode(false);
      }
      this.$emit("showaddress", this.servicekleber.address);
    },
    removeTib(tibModel) {
      console.info("removeTib");
      var index = this.servicekleber.tibs.indexOf(tibModel);
      if (index > -1) {
        this.servicekleber.tibs.splice(index, 1);
      }
    },
    focusNameInput() {
      this.$nextTick(() => {
        this.$refs.nameInput.focus();
        this.$refs.nameInput.select();
      });
    },
    newMessage(text) {
      console.info("view.newMessage");
      this.$refs.journalComponent.newMessage(text);
    }
  },
  props: {
    servicekleberProperty: Object,
    doEditProperty: Boolean,
    newTibTagProperty: String,
    tp: Object
  }
};
</script>
